import * as translationTypes from "../types/translationTypes";

export const setCurrentLanguage = (lang) => ({
  type: translationTypes.SET_CURRENT_LANGUAGE,
  payload: lang || "en",
});
